export default class OhsAdaOrgAdminFilterModels {
  viewPreset: 'view_1' | 'view_2';

  page: number;

  next: string;

  sort: string;

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor() {
    this.viewPreset = 'view_1'; // Default view preset
    this.page = 1; // Default page number
    this.next = ''; // Default next page token
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'ID: High to Low ', value: '{ "key": "_id", "order": -1 }' },
        { name: 'ID: Low to High', value: '{ "key": "_id", "order": 1 }' },
        { name: 'Org Name: : A to Z', value: '{ "key": "name", "order": 1 }' },
        { name: 'Org Name: : Z to A', value: '{ "key": "name", "order": -1 }' },
      ],
    };
    this.sort = '{ "key": "name", "order": 1 }'; // Default sort by name ascending
  }
}
